import React, { useState, useRef, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import Typography from "@mui/material/Typography";
import {
  GetUser,
  GetCompany,
  GetPolicyList,
  VerifyPolicyNumber,
  LoginPortalData,
  CreatePolicyMappingService,
  retreiveDataFromPolicy,
  GetCompanyLogin,
  GetFuelType,
  GetVehicleMake,
  PostBulkUploadExcelFile,
} from "../../../Service/_index";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import { Formik, Form, Field, useFormikContext } from "formik";
import Box from "@mui/material/Box";
import {
  PostCreatePolicy,
  AutoFillPolicyDetails,
} from "../../../Service/_index";
import Autocomplete from "@mui/material/Autocomplete";
import { ToastError, ToastSuccess } from "../../../UiComponents/Toaster/Toast";
import * as Yup from "yup";
import { FileUploader } from "react-drag-drop-files";
import swal from "../../../Shared/swal";
import {
  AWS_DIRECTORY_NAME,
  checkUserType,
} from "../../../Shared/CommonConstant";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import AddCompany from "../../Master/CreateCompany/AddCompany";
import Loader from "../../../UiComponents/Loader/Loader";
import Dialog from "@mui/material/Dialog";
import { Transition } from "../../../UiComponents/Transition/Transition";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { DatePicker, Space } from "antd";
import Styles from "../../../UiComponents/Scss/AddPopup.module.scss";
import { Button, Divider } from "@mui/material";
import { AddIcon } from "../../../Resources/Icons/icons";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ExcelJS from "exceljs";
import BulkUploadPreview from "./BulkUploadPreview";
const PaymentDetails = [
  {
    label: "Cash",
    value: 1,
  },
  {
    label: "Online",
    value: 2,
  },
  {
    label: "Cheque",
    value: 3,
  },
  {
    label: "DD",
    value: 4,
  },
];

const BULK_COMPANY_OPTIONS = [
  { label: "Reliance", value: "reliance" },
  { label: "National", value: "national" },
  { label: "United", value: "united" },
];

const initialValues = {
  userId: "",
  issueDate: "",
  companyId: "",
  loginId: {
    //added by gokul
    companyId: "",
    userId: "",
  },
  loginIdFull: "", //added by gokul
  bookingCode: "", //Added by Arun
  subBookingCode: "", //Added by Arun
  bookingCodeId: "", //Added by Arun
  subBookingCodeId: "", //Added by Arun
  policyNumber: "",
  totalPremium: "",
  paymentMode: "",
  chequeNumber: "",
  chequeDate: "",
  bankName: "",
  PolicyFile: "",
  OtherFile: "",
  policyPortal: "",
};

const PolicyPortal = [
  {
    label: "Company Portal",
    value: 1,
  },
  {
    label: "Broker Portal",
    value: 2,
  },
];

const Policycreate = () => {
  const formRef = useRef(null);
  const bulkFileInputRef = useRef(null);
  const UserType = sessionStorage.getItem("userType");
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [showPaymentMethod, setShowPaymentMethod] = useState("");
  const [policyNumbers, setPolicyNumbers] = useState([]);
  const [openCompanyDrawer, setOpenCompanyDrawer] = React.useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectPortal, setSelectedPortal] = useState("");
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [refreshCount, setRefreshCount] = useState(0);
  const [refreshPolicyNumber, setRefreshPolicyNumber] = useState(0);
  const [openLoader, setOpenLoader] = useState(false);
  const [showPolicyErrMsg, setShowPolicyErrMsg] = useState("");
  const [isAllow, setIsAllow] = useState({});
  const [resetFileKey, setResetFileKey] = useState(1);
  const [fileTitle, setFileTitle] = useState({});
  const [disable, setDisable] = useState(true);
  const [displayMappingBtn, setDisplayMappingBtn] = useState(false); //Changes by Arun
  const [pdfData, setPdfData] = useState({});
  const [bulkDialogOpen, setBulkDialogOpen] = useState(false);
  const [bulkCompany, setBulkCompany] = useState(null);
  const [bulkFileName, setBulkFileName] = useState("");
  const [bulkPreview, setBulkPreview] = useState([]);
  const [bulkResults, setBulkResults] = useState(null);
  const [bulkProcessing, setBulkProcessing] = useState(false);
  const [companyLoginLookup, setCompanyLoginLookup] = useState({});
  const [fuelTypeLookup, setFuelTypeLookup] = useState({});
  const [vehicleMakeLookup, setVehicleMakeLookup] = useState({});
  const [bulkSheetName, setBulkSheetName] = useState("");
  const [bulkFileNameError, setBulkFileNameError] = useState("");
  const [bulkFileObject, setBulkFileObject] = useState(null);

  const normalizeHeader = (header) => {
    if (header === undefined || header === null) {
      return "";
    }
    if (typeof header === "object") {
      const values =
        typeof header.values === "function"
          ? header.values()
          : Array.isArray(header.values)
            ? header.values
            : Object.values(header).filter((val) => val !== undefined && val !== null);
      return normalizeHeader(values[0]);
    }
    return header
      .toString()
      .trim()
      .replace(/[\s]+/g, " ")
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace(/[^a-z0-9_]/g, "_");
  };

  const normalizeLoginIdentifier = (value) => {
    if (value === undefined || value === null) return "";
    return value
      .toString()
      .trim()
      .replace(/'/g, "")
      .toUpperCase();
  };

  const extractCellValue = (value) => {
    if (value === undefined || value === null) return "";
    if (value instanceof Date) return value;
    if (typeof value === "number" || typeof value === "boolean") return value;

    if (typeof value === "object") {
      if (Array.isArray(value.richText)) {
        return value.richText.map((part) => part.text || "").join("");
      }

      if (value.text) {
        return value.text;
      }

      if (value.result !== undefined && value.result !== null) {
        return extractCellValue(value.result);
      }

      if (value.formattedText) {
        return extractCellValue(value.formattedText);
      }

      if (value.hyperlink && value.text) {
        return value.text;
      }

      if (typeof value.values === "function") {
        const evaluated = value.values();
        if (Array.isArray(evaluated) && evaluated.length) {
          return extractCellValue(evaluated[0]);
        }
      }

      if (Array.isArray(value)) {
        return value.map((entry) => extractCellValue(entry)).join("");
      }

      if (value.toString && value.toString() !== "[object Object]") {
        return value.toString();
      }

      return "";
    }

    return value;
  };

  const getRecordValue = (record, keys, defaultValue = "") => {
    for (const key of keys) {
      const normalizedKey = normalizeHeader(key);
      if (
        record[normalizedKey] !== undefined &&
        record[normalizedKey] !== null &&
        record[normalizedKey] !== ""
      ) {
        return record[normalizedKey];
      }

      if (
        record[key] !== undefined &&
        record[key] !== null &&
        record[key] !== ""
      ) {
        return record[key];
      }
    }
    return defaultValue;
  };

  function parseExcelDate(value) {
    if (value === undefined || value === null || value === "") return null;
    if (value instanceof Date) return value;
    if (typeof value === "number") {
      const excelEpoch = new Date(Math.round((value - 25569) * 86400 * 1000));
      if (!Number.isNaN(excelEpoch.getTime())) {
        return excelEpoch;
      }
    }
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.toDate() : null;
  }

  const DEFAULT_PAYMENT_MODE = "Online";
  const DEFAULT_POLICY_PORTAL = "Company Portal";

  const BULK_FIELD_MAPPINGS = [
    {
      label: "Policy Number",
      formKey: "policyNumber",
      keys: ["policy_number", "policy_no", "policyno", "policy"],
    },
    {
      label: "Customer Name",
      formKey: "customerName",
      keys: ["customername", "customer_name"],
    },
    {
      label: "Make",
      formKey: "make",
      keys: ["make"],
    },
    {
      label: "Model",
      formKey: "model",
      keys: ["model"],
    },
    {
      label: "Fuel Type",
      formKey: "fuelType",
      keys: ["fueltype", "fuel_type"],
    },
    {
      label: "Vehicle No",
      formKey: "registrationNumber",
      keys: ["vechileno", "vehicleno", "vehicle_no", "vehiclenumber"],
    },
    {
      label: "Year Of Manufacture",
      formKey: "registrationYear",
      keys: ["yearofmanufacture", "manufacturingyear"],
    },
    {
      label: "OD Discount",
      formKey: "odDisc",
      keys: ["oddiscount"],
    },
    {
      label: "Prop Date",
      formKey: "issueDate",
      keys: ["propdate", "issue_date", "issuedate", "policystartdate", "transationdate"],
      transform: parseExcelDate,
    },
    {
      label: "OD Net Premium",
      formKey: "odPremium",
      keys: ["odnetpremium", "od_net_premium"],
    },
    {
      label: "TP Premium",
      formKey: "tpPremium",
      keys: ["tppremium"],
    },
    {
      label: "Gross Premium",
      formKey: "totalPremium",
      keys: ["grosspremium", "total_premium", "totalpremium"],
    },
    {
      label: "CC",
      formKey: "cc",
      keys: ["cc"],
    },
    {
      label: "Seating Capacity",
      formKey: "seatingCapacity",
      keys: ["seatingcapacity"],
    },
    {
      label: "Add-On Premium",
      formKey: "addOnPremium",
      keys: ["addonpremium", "add_on_premium"],
    },
    {
      label: "User ID",
      formKey: "loginIdFull",
      keys: ["userid", "user_id", "userID"],
    },
  ];

  const isValueEmpty = (value) =>
    value === undefined ||
    value === null ||
    (typeof value === "string" && value.trim() === "");

  useEffect(() => {
    let isSubscribed = true;
    GetCompanyLogin()
      .then((res) => {
        if (!isSubscribed || !res?.data) return;
        const lookup = {};
        res.data.forEach((item) => {
          const normalizedId = normalizeLoginIdentifier(
            item?.userIdNumber || item?.loginId || item?.loginPortal
          );
          const resolvedCompanyId =
            item?.companyId?._id ||
            (typeof item?.companyId === "string" ? item.companyId : "");
          if (!normalizedId || !resolvedCompanyId) {
            return;
          }
          lookup[normalizedId] = {
            companyId: resolvedCompanyId,
            companyName:
              item?.companyId?.shortName ||
              item?.companyId?.companyName ||
              "",
            userId:
              item?.userId?._id ||
              (typeof item?.userId === "string" ? item.userId : ""),
            bookingCodeId:
              item?.bookingCodeId?._id ||
              (typeof item?.bookingCodeId === "string"
                ? item?.bookingCodeId
                : ""),
            subBookingCodeId:
              item?.subBookingCodeId?._id ||
              (typeof item?.subBookingCodeId === "string"
                ? item?.subBookingCodeId
                : ""),
            bookingCode:
              item?.bookingCodeId?.bookingCode || item?.bookingCode || "",
            subBookingCode:
              item?.subBookingCodeId?.subBookingCode ||
              item?.subBookingCode ||
              "",
          };
        });
        setCompanyLoginLookup(lookup);
      })
      .catch((error) => {
        console.error("Failed to load company login lookup", error);
      });

    return () => {
      isSubscribed = false;
    };
  }, []);

  // Fetch fuel types for bulk upload
  useEffect(() => {
    let isSubscribed = true;
    GetFuelType()
      .then((res) => {
        if (!isSubscribed || !res?.data) return;
        const lookup = {};
        res.data.forEach((item) => {
          if (item?.fuelType && item?._id) {
            // Create case-insensitive lookup by fuel type name
            const fuelTypeName = item.fuelType.trim().toLowerCase();
            lookup[fuelTypeName] = item._id;
          }
        });
        setFuelTypeLookup(lookup);
      })
      .catch((error) => {
        console.error("Failed to load fuel type lookup", error);
      });

    return () => {
      isSubscribed = false;
    };
  }, []);

  // Fetch vehicle makes for bulk upload
  useEffect(() => {
    let isSubscribed = true;
    GetVehicleMake({ isAscending: true })
      .then((res) => {
        if (!isSubscribed || !res?.data) return;
        const lookup = {};
        res.data.forEach((item) => {
          if (item?.vehicleMake && item?._id) {
            // Create case-insensitive lookup by vehicle make name
            const vehicleMakeName = item.vehicleMake.trim().toLowerCase();
            lookup[vehicleMakeName] = item._id;
          }
        });
        setVehicleMakeLookup(lookup);
      })
      .catch((error) => {
        console.error("Failed to load vehicle make lookup", error);
      });

    return () => {
      isSubscribed = false;
    };
  }, []);

  const mapBulkRecord = (record) => {
    const values = {};
    const missing = [];
    const warnings = [];

    BULK_FIELD_MAPPINGS.forEach((mapping) => {
      const rawValue = getRecordValue(record, mapping.keys, "");
      let transformedValue =
        mapping.transform && !isValueEmpty(rawValue)
          ? mapping.transform(rawValue)
          : rawValue;

      // Trim string values for make, fuelType, and loginIdFull
      if (mapping.formKey === "make" || mapping.formKey === "fuelType" || mapping.formKey === "loginIdFull") {
        if (typeof transformedValue === "string") {
          transformedValue = transformedValue.trim();
        }
      }

      values[mapping.formKey] = transformedValue;

      if (isValueEmpty(transformedValue)) {
        missing.push(mapping.label);
      }
    });

    // Validate Vehicle Make - trim and lowercase for comparison
    if (!isValueEmpty(values.make) && Object.keys(vehicleMakeLookup).length > 0) {
      const makeValue = typeof values.make === "string" ? values.make : String(values.make);
      const vehicleMakeName = makeValue.trim().toLowerCase();
      const vehicleMakeId = vehicleMakeLookup[vehicleMakeName];
      if (!vehicleMakeId) {
        warnings.push(`Vehicle Make "${makeValue.trim()}" not found in database`);
      }
    }

    // Validate Fuel Type - trim and lowercase for comparison
    if (!isValueEmpty(values.fuelType) && Object.keys(fuelTypeLookup).length > 0) {
      const fuelTypeValue = typeof values.fuelType === "string" ? values.fuelType : String(values.fuelType);
      const fuelTypeName = fuelTypeValue.trim().toLowerCase();
      const fuelTypeId = fuelTypeLookup[fuelTypeName];
      if (!fuelTypeId) {
        warnings.push(`Fuel Type "${fuelTypeValue.trim()}" not found in database`);
      }
    }

    // Validate UserID/LoginID - normalize and check against company login lookup
    if (!isValueEmpty(values.loginIdFull) && Object.keys(companyLoginLookup).length > 0) {
      const loginIdValue = typeof values.loginIdFull === "string" ? values.loginIdFull : String(values.loginIdFull);
      const normalizedLoginId = normalizeLoginIdentifier(loginIdValue);
      const matchedLogin = normalizedLoginId ? companyLoginLookup[normalizedLoginId] : null;
      if (!matchedLogin) {
        warnings.push(`User ID "${loginIdValue.trim()}" not found in database Company Login`);
      }
    }

    return { values, missing, warnings };
  };

  const resolveCompanyDetails = (selectedOption) => {
    if (!selectedOption) return null;
    const companyKey =
      selectedOption.value || selectedOption.label || selectedOption;
    if (!companyKey) return null;
    const normalizedKey = companyKey.toString().toLowerCase();
    return (
      companyDetails.find(
        (company) =>
          company?.label?.toLowerCase() === normalizedKey ||
          company?.shortName?.toLowerCase() === normalizedKey ||
          company?.companyName?.toLowerCase() === normalizedKey
      ) || null
    );
  };

  const validateBulkFileName = (fileName, selectedCompany) => {
    if (!selectedCompany || !fileName) {
      return { isValid: false, error: "" };
    }

    const companyName = selectedCompany.label || selectedCompany.value || "";
    if (!companyName) {
      return { isValid: false, error: "" };
    }

    // Remove file extension and convert to lowercase for comparison
    const fileNameWithoutExt = fileName.replace(/\.(xlsx|xls)$/i, "").trim();
    const actualFileName = fileNameWithoutExt.toLowerCase();
    const companyNameLower = companyName.toLowerCase();

    // Check if file name contains the selected company name
    // if (!actualFileName.includes(companyNameLower)) {
    //   return {
    //     isValid: false,
    //     error: `File name must include the company name "${companyName}". Current file: ${fileName}`,
    //   };
    // }

    // Check if file name contains any other company names (not allowed)
    // const otherCompanies = BULK_COMPANY_OPTIONS.filter(
    //   (company) => company.label.toLowerCase() !== companyNameLower
    // );

    // for (const otherCompany of otherCompanies) {
    //   const otherCompanyNameLower = otherCompany.label.toLowerCase();
    //   if (actualFileName.includes(otherCompanyNameLower)) {
    //     return {
    //       isValid: false,
    //       error: `File name cannot contain multiple company names. Selected: "${companyName}", but file also contains "${otherCompany.label}". Please use only "${companyName}" in the file name.`,
    //     };
    //   }
    // }

    // File name contains only the selected company name
    return { isValid: true, error: "" };
  };

  const resetBulkState = () => {
    setBulkFileName("");
    setBulkPreview([]);
    setBulkResults(null);
    setBulkProcessing(false);
    setBulkSheetName("");
    setBulkFileNameError("");
    setBulkFileObject(null);
    if (bulkFileInputRef.current) {
      bulkFileInputRef.current.value = "";
    }
  };

  const parseExcelFile = async (file) => {
    try {
      const workbook = new ExcelJS.Workbook();
      const arrayBuffer = await file.arrayBuffer();
      await workbook.xlsx.load(arrayBuffer);
      const worksheet = workbook.worksheets[0];

      if (!worksheet) {
        ToastError("Unable to find data sheet in the uploaded file.");
        return null;
      }

      let headerRow = worksheet.getRow(1);
      let headerRowIndex = headerRow.number;
      let headers = headerRow.values
        .slice(1)
        .map((header) => normalizeHeader(header));

      if (!headers.length || headers.every((header) => !header)) {
        // Try to detect headers by scanning rows until first non-empty row
        for (let rowIndex = 1; rowIndex <= worksheet.rowCount; rowIndex++) {
          const candidateRow = worksheet.getRow(rowIndex);
          const candidateValues = candidateRow.values
            .slice(1)
            .map((header) => normalizeHeader(header));

          const hasContent = candidateValues.some((value) => value);
          if (hasContent) {
            headerRow = candidateRow;
            headerRowIndex = candidateRow.number;
            headers = candidateValues;
            break;
          }
        }
      }

      if (!headers.length || headers.every((header) => !header)) {
        ToastError("No headers found in the uploaded Excel file.");
        return null;
      }

      const records = [];
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === headerRowIndex) return;
        const values = row.values;
        const record = {};

        headers.forEach((headerKey, index) => {
          if (!headerKey) return;
          const cellValue = extractCellValue(values[index + 1] ?? "");
          if (typeof cellValue === "string") {
            record[headerKey] = cellValue.trim();
          } else {
            record[headerKey] = cellValue;
          }
        });

        const hasContent = Object.values(record).some(
          (val) => val !== undefined && val !== null && val !== ""
        );
        if (hasContent) {
          record.__rowNumber = rowNumber;
          const mapped = mapBulkRecord(record);
          record.__extracted = mapped.values;
          record.__missingFields = mapped.missing;
          record.__warnings = mapped.warnings || [];
          records.push(record);
        }
      });

      if (!records.length) {
        ToastError("No data rows identified in the uploaded Excel file.");
        return null;
      }

      return records;
    } catch (error) {
      console.error("Bulk upload parse error:", error);
      ToastError("Unable to read the uploaded Excel file.");
      return null;
    }
  };

  const handleBulkDialogOpen = () => {
    setBulkDialogOpen(true);
    setBulkResults(null);
  };

  const handleBulkDialogClose = () => {
    if (bulkProcessing) return;
    resetBulkState();
    setBulkCompany(null);
    setBulkDialogOpen(false);
  };

  const handleBulkFileChange = async (event) => {
    const file = event?.target?.files?.[0];
    if (event?.target) {
      event.target.value = "";
    }
    setBulkResults(null);
    setBulkPreview([]);
    setBulkFileName("");
    setBulkFileNameError("");

    if (!file) {
      return;
    }

    // Store the file object for potential re-parsing
    setBulkFileObject(file);
    setBulkFileName(file.name);

    // Company selection is mandatory
    if (!bulkCompany) {
      ToastError("Please select a company before uploading the Excel file.");
      setBulkFileNameError("Company selection is required before uploading file.");
      return;
    }

    // Validate file name - company is selected
    const validation = validateBulkFileName(file.name, bulkCompany);
    if (!validation.isValid) {
      setBulkFileNameError(validation.error);
      ToastError(validation.error);
      return;
    }
    setBulkFileNameError("");

    // Parse the file
    const records = await parseExcelFile(file);
    if (records) {
      setBulkPreview(records);
    } else {
      setBulkFileName("");
      setBulkFileObject(null);
    }
  };

  const handleBulkCreate = async () => {
    // Company selection is mandatory
    if (!bulkCompany) {
      ToastError("Please select a company before processing.");
      return;
    }

    if (!bulkPreview.length) {
      ToastError("Please upload an Excel file with policy data.");
      return;
    }

    // Validate file name before processing
    if (bulkFileName) {
      const validation = validateBulkFileName(bulkFileName, bulkCompany);
      if (!validation.isValid) {
        setBulkFileNameError(validation.error);
        ToastError(validation.error);
        return;
      }
    }

    const companyInfo = resolveCompanyDetails(bulkCompany);
    if (!companyInfo) {
      ToastError(
        "Selected company is not available. Please add it to the master before proceeding."
      );
      return;
    }

    const companyIdForBulk =
      companyInfo?.value || companyInfo?._id || companyInfo?.id || "";

    setBulkProcessing(true);
    setOpenLoader(true);

    // First, validate all records to check if at least one will succeed
    const validationResults = [];
    for (const record of bulkPreview) {
      const mapped =
        record.__extracted && record.__missingFields
          ? { values: record.__extracted, missing: record.__missingFields }
          : mapBulkRecord(record);

      const extractedValues = mapped.values;
      const policyNumberValue = extractedValues.policyNumber;

      // Check if this record has minimum required fields
      if (!policyNumberValue) {
        validationResults.push({ valid: false, row: record.__rowNumber });
        continue;
      }

      // Check if company can be determined
      const normalizedLoginId = normalizeLoginIdentifier(
        extractedValues.loginIdFull
      );
      const matchedLogin = normalizedLoginId
        ? companyLoginLookup[normalizedLoginId]
        : null;
      const companyIdFromLogin = matchedLogin?.companyId || "";
      const companyIdToUse = companyIdFromLogin || companyIdForBulk;

      if (!companyIdToUse) {
        validationResults.push({ valid: false, row: record.__rowNumber });
        continue;
      }

      validationResults.push({ valid: true, row: record.__rowNumber });
    }

    // Check if at least one record is valid
    const hasValidRecords = validationResults.some((result) => result.valid);

    if (!hasValidRecords) {
      ToastError("No valid records found. All records have errors. Cannot proceed with bulk upload.");
      setBulkProcessing(false);
      setOpenLoader(false);
      return;
    }

    // Upload Excel file to S3 and save BulkUploadExcelFile record only if we have valid records
    let bulkUploadExcelFileId = null;
    if (bulkFileObject) {
      try {
        const UserName = sessionStorage.getItem("UserId");
        const formData = new FormData();
        formData.append("excelFile", bulkFileObject);
        formData.append("companyName", bulkCompany.label || bulkCompany.value || "");
        formData.append("createdBy", UserName || "");

        const uploadResponse = await PostBulkUploadExcelFile(formData);
        if (uploadResponse?.error) {
          setBulkProcessing(false);
          setOpenLoader(false);
          return;
        }
        bulkUploadExcelFileId = uploadResponse?.data?._id || uploadResponse?._id;
      } catch (error) {
        console.error("Failed to upload Excel file:", error);
        ToastError("Failed to upload Excel file. Please try again.");
        setBulkProcessing(false);
        setOpenLoader(false);
        return;
      }
    }

    const results = { success: 0, failed: 0, errors: [] };

    for (const record of bulkPreview) {
      const mapped =
        record.__extracted && record.__missingFields
          ? { values: record.__extracted, missing: record.__missingFields }
          : mapBulkRecord(record);

      const extractedValues = mapped.values;

      const policyNumberValue = extractedValues.policyNumber;

      if (!policyNumberValue) {
        results.failed += 1;
        results.errors.push({
          row: record.__rowNumber,
          message: "Policy number is missing.",
        });
        continue;
      }

      const formData = new FormData();
      formData.append("policyNumber", policyNumberValue.toString().trim());

      // ✅ FIX: Only append issueDate if it exists in Excel - don't default to current date
      if (!isValueEmpty(extractedValues.issueDate)) {
        formData.append("issueDate", extractedValues.issueDate);
      }
      // If issueDate is missing, policy will be created without it (can be added later via correction Excel)

      if (!isValueEmpty(extractedValues.totalPremium)) {
        formData.append("totalPremium", extractedValues.totalPremium);
      }

      const normalizedLoginId = normalizeLoginIdentifier(
        extractedValues.loginIdFull
      );
      const matchedLogin = normalizedLoginId
        ? companyLoginLookup[normalizedLoginId]
        : null;

      if (matchedLogin?.userId) {
        formData.append("userId", matchedLogin.userId);
      }

      // ✅ FIX: Determine company priority:
      // 1. If UserID provided and matched in companyLogin → use that company
      // 2. If UserID provided but not matched → fail with error
      // 3. If no UserID provided → use bulk company ONLY if explicitly selected
      const companyIdFromLogin = matchedLogin?.companyId || "";

      let companyIdToUse = "";
      let companySource = "";

      if (normalizedLoginId) {
        // UserID was provided
        if (companyIdFromLogin) {
          companyIdToUse = companyIdFromLogin;
          companySource = "companyLogin";
        } else {
          // UserID provided but not found in companyLogin - this is an error
          results.failed += 1;
          results.errors.push({
            row: record.__rowNumber,
            message: `User ID "${extractedValues.loginIdFull}" not found in Company Login. Please provide a valid User ID or leave it blank.`,
          });
          continue;
        }
      } else {
        // No UserID provided
        if (companyIdForBulk) {
          // Bulk company was selected - use it but flag as bulk default
          companyIdToUse = companyIdForBulk;
          companySource = "bulkDefault";
        } else {
          // No UserID and no bulk company - create without company (can be added later)
          companySource = "none";
        }
      }

      // Only append companyId if we have one
      if (companyIdToUse) {
        formData.append("companyId", companyIdToUse);

        // Log for debugging
        if (companySource === "bulkDefault") {
          console.log(
            `ℹ️  Policy ${policyNumberValue}: Using bulk default company (no UserID provided)`
          );
        }
      }
      formData.append("paymentMode", DEFAULT_PAYMENT_MODE);
      formData.append("policyPortal", DEFAULT_POLICY_PORTAL);
      formData.append("source", "ONLINE");

      if (matchedLogin?.companyId) {
        const loginPayload = {
          companyId: matchedLogin.companyId,
        };
        if (matchedLogin?.userId) {
          loginPayload.userId = matchedLogin.userId;
        }
        if (matchedLogin?.bookingCodeId) {
          loginPayload.bookingCodeId = matchedLogin.bookingCodeId;
          formData.append("bookingCodeId", matchedLogin.bookingCodeId);
        }
        if (matchedLogin?.subBookingCodeId) {
          loginPayload.subBookingCodeId = matchedLogin.subBookingCodeId;
          formData.append("subBookingCodeId", matchedLogin.subBookingCodeId);
        }
        if (matchedLogin?.bookingCode) {
          formData.append("bookingCode", matchedLogin.bookingCode);
        }
        if (matchedLogin?.subBookingCode) {
          formData.append("subBookingCode", matchedLogin.subBookingCode);
        }
        formData.append("loginId", JSON.stringify(loginPayload));
      }

      if (!isValueEmpty(extractedValues.registrationNumber)) {
        formData.append("registrationNumber", extractedValues.registrationNumber);
      }
      if (!isValueEmpty(extractedValues.customerName)) {
        formData.append("customerName", extractedValues.customerName);
      }
      if (!isValueEmpty(extractedValues.model)) {
        formData.append("model", extractedValues.model);
      }
      if (!isValueEmpty(extractedValues.registrationYear)) {
        formData.append("registrationYear", extractedValues.registrationYear);
      }
      if (!isValueEmpty(extractedValues.odDisc)) {
        formData.append("odDisc", extractedValues.odDisc);
      }
      if (!isValueEmpty(extractedValues.odPremium)) {
        formData.append("odPremium", extractedValues.odPremium);
      }
      if (!isValueEmpty(extractedValues.tpPremium)) {
        formData.append("tpPremium", extractedValues.tpPremium);
      }
      if (!isValueEmpty(extractedValues.cc)) {
        formData.append("cc", extractedValues.cc);
      }
      if (!isValueEmpty(extractedValues.seatingCapacity)) {
        formData.append("seatingCapacity", extractedValues.seatingCapacity);
      }
      if (!isValueEmpty(extractedValues.addOnPremium)) {
        formData.append("addOnPremium", extractedValues.addOnPremium);
      }

      if (!isValueEmpty(extractedValues.loginIdFull)) {
        formData.append("loginIdFull", extractedValues.loginIdFull);
      }

      // Handle FuelType lookup and mapping - trim and lowercase for comparison
      if (!isValueEmpty(extractedValues.fuelType)) {
        const fuelTypeValue = typeof extractedValues.fuelType === "string"
          ? extractedValues.fuelType
          : String(extractedValues.fuelType);
        const fuelTypeName = fuelTypeValue.trim().toLowerCase();
        const fuelTypeId = fuelTypeLookup[fuelTypeName];
        if (fuelTypeId) {
          formData.append("fuelType", fuelTypeId);
        } else {
          // Log warning but don't fail the record
          console.warn(
            `Fuel type "${fuelTypeValue.trim()}" not found in lookup for row ${record.__rowNumber}`
          );
        }
      }

      // Handle VehicleMake lookup and mapping - trim and lowercase for comparison
      if (!isValueEmpty(extractedValues.make)) {
        const makeValue = typeof extractedValues.make === "string"
          ? extractedValues.make
          : String(extractedValues.make);
        const vehicleMakeName = makeValue.trim().toLowerCase();
        const vehicleMakeId = vehicleMakeLookup[vehicleMakeName];
        if (vehicleMakeId) {
          formData.append("make", vehicleMakeId);
        } else {
          // Log warning but don't fail the record
          console.warn(
            `Vehicle make "${makeValue.trim()}" not found in lookup for row ${record.__rowNumber}`
          );
        }
      }

      // Set isBulkUpload flag for bulk uploads
      formData.append("isBulkUpload", true);

      // Add BulkUploadExcelFile _id if available
      if (bulkUploadExcelFileId) {
        formData.append("BulkUploadExecelFile", bulkUploadExcelFileId);
      }

      try {
        const response = await PostCreatePolicy(formData, {
          suppressToast: true,
        });
        if (response?.error) {
          results.failed += 1;
          results.errors.push({
            row: record.__rowNumber,
            message: response?.message || "Policy API rejected the request.",
          });
        } else {
          results.success += 1;
        }
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "Unable to create policy";
        results.failed += 1;
        results.errors.push({
          row: record.__rowNumber,
          message,
        });
      }
    }

    setBulkResults(results);
    setOpenLoader(false);
    setBulkProcessing(false);

    // If Excel file was uploaded but all policies failed, show warning
    if (bulkUploadExcelFileId && results.success === 0 && results.failed > 0) {
      ToastError(
        `All policies failed to create. The Excel file was uploaded but no policies were created. Please fix the errors and try again.`
      );
    } else if (results.success > 0) {
      ToastSuccess(`${results.success} policies created successfully.`);
      GetPolicyDetails();
    }

    if (results.failed > 0 && results.success > 0) {
      ToastError(
        `${results.failed} policies failed to create. Please review the errors.`
      );
    }
  };

  const CreatePolicySchema = Yup.object().shape({
    policyNumber: Yup.string().required("Policy Number Required"),
    userId: Yup.string().required("User Name Required"),
    companyId: Yup.string().required("Company Name Required"),
    issueDate: Yup.string().required("Issue Date Required"),
    totalPremium: Yup.string().required("Total Premium Required"),
    policyPortal: Yup.string().required("Policy Portal Required"),
    paymentMode: Yup.string().required("Payment Mode Required"),
    PolicyFile: Yup.string().required("Policy File Required"),
    chequeNumber: Yup.string().required("Cheque Number Required"),
    chequeDate: Yup.string().required("Cheque Date Required"),
    bankName: Yup.string().required("Bank Name Required"),
    // loginIdFull: Yup.string().required("LoginId is required"),
  });

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompanyDetails = res?.data
        .filter((e) => e.isEnabled === true)
        .map((e) => {
          return {
            ...e,
            label: e.shortName,
            value: e._id,
          };
        })
        .filter(Boolean);

      setCompanyDetails(modifiedCompanyDetails);
    });
  };
  const GetUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    GetUser(bodyData).then((res) => {
      const modifiedUserDetails = res?.data
        ?.map((e) => {
          if (e.userType.includes("user") && e.isEnabled === true) {
            return {
              ...e,
              label: e.name + " - " + e.mobileNumber + " - " + e.email,
              value: e._id,
            };
          }
        })
        .filter(Boolean);
      setUserDetails(modifiedUserDetails);
    });
  };

  // Added by Arun
  const AutoFillFunction = (data) => {
    if (!data.PolicyFile) {
      ToastError("Please, Upload policy file");
      return true;
    }
    setOpenLoader(true);
    let formData = new FormData();
    formData.append(
      AWS_DIRECTORY_NAME.AWS_POLICY_FILE_DIRECTORY_NAME,
      data?.PolicyFile
    );

    retreiveDataFromPolicy(formData).then((res) => {
      setOpenLoader(false);
      // formRef.current?.setFieldValue("cc", res?.data?.cc);
      // formRef.current?.setFieldValue("gvw", res?.data?.gvw);
      setPdfData(res?.data);
      formRef.current?.setFieldValue("policyNumber", res?.data?.policyNumber);
      // formRef.current?.setFieldValue(
      //   "registrationNumber",
      //   res?.data?.registrationNumber
      // );
      // formRef.current?.setFieldValue("registrationYear", res?.data?.registrationYear);
      // formRef.current?.setFieldValue("seatingCapacity", res?.data?.seatingCapacity);
      formRef.current?.setFieldValue(
        "totalPremium",
        String(res?.data?.totalPremium)?.replace(/,/g, "")
      );
      const ResCompany = res.data.companyName ? res.data.companyName : "";
      const foundCompany = companyDetails.find(
        (company) => company.companyName === ResCompany.toUpperCase()
      );
      if (res?.data?.issueDate) {
        const dateStr = res.data.issueDate;
        const daysjsDate = dayjs(dateStr, "DD/MM/YYYY");
        console.log("daysjsDate -----", daysjsDate);
        formRef.current?.setFieldValue("issueDate", daysjsDate.$d);
      }
      // if (foundCompany) {
      //   formRef.current?.setFieldValue("companyId", foundCompany?.value);
      //   setSelectedCompany(foundCompany?.companyName);
      // } else {
      //   formRef.current?.setFieldValue("companyId", null);
      //   setSelectedCompany("");
      //   ToastError(
      //     `" ${ResCompany.toUpperCase()} "  Not added yet, Please add that Company !`
      //   );
      // }
    });
  };

  const GetPolicyDetails = () => {
    GetPolicyList().then((res) => {
      const policyNumbers = res?.data?.map((e) => e.policyNumber);
      setPolicyNumbers(policyNumbers);
    });
  };

  const BackToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  React.useEffect(() => {
    GetUserDetails();
    GetCompanyDetails();
    GetPolicyDetails();
  }, []);

  const PaymentFunction = (e) => {
    setShowPaymentMethod(e?.value);
    formRef.current?.setFieldValue("paymentMode", e?.label);
  };

  const LoginUserId = sessionStorage.getItem("UserId");

  // const { values } = useFormikContext();
  // const SaveAndExit = (values, action) => {
  //   console.log(values); // Now you can use Formik values here
  //   // Perform your save and exit logic
  // };

  const SaveAndExit = (data, keys) => {
    const UserName = sessionStorage.getItem("UserId");
    data.userId = isAllow.isUser ? LoginUserId : data?.userId;
    data.policyNumber = data.policyNumber?.replace(/[^a-zA-Z0-9/-]/g, "");
    data.totalPremium = String(data?.totalPremium)?.replace(/,/g, "");
    data.createdBy = UserName;
    let formData = new FormData();
    for (var key in data) {
      formData.append(key, data[key]);
    }
    const loginId = data?.loginId;
    formData.set("loginId", JSON.stringify(loginId));
    formData.append(
      AWS_DIRECTORY_NAME.AWS_POLICY_FILE_DIRECTORY_NAME,
      data?.PolicyFile
    );
    formData.append(
      AWS_DIRECTORY_NAME.AWS_OTHER_FILE_DIRECTORY_NAME,
      data.OtherFile
    );

    console.log("Form:", formData);

    // const validateUser = data?.loginIdFull && UserType==="CLIENT"
    // const validatePolicyPortal = data?.policyPortal && UserType === "CLIENT";
    // console.log(data?.PolicyFile)
    if (
      data?.userId &&
      data?.PolicyFile &&
      data?.issueDate &&
      data?.companyId &&
      data?.policyNumber &&
      data?.totalPremium &&
      data?.paymentMode
      // (UserType === "CLIENT" ? (data?.loginIdFull ? true : false) : true) &&
      // (UserType === "CLIENT" ? (data?.policyPortal ? true : false) : true)
    ) {
      setOpenLoader(true);
      // Changes by Arun
      if (displayMappingBtn) {
        CreatePolicyMappingService(formData)
          .then((res) => {
            setOpenLoader(false);
            navigate("/policyList");
            swal({
              title: "Policy Mapping Created Successfully!",
              icon: "success",
              buttons: true,
            });
          })
          .catch((err) => ToastError(err));
      }
      // End of changes
      else {
        if (UserType == "user") {
          formData.delete("bookingCodeId");
          formData.delete("subBookingCodeId");
        }
        PostCreatePolicy(formData)
          .then((res) => {
            if (res?.error) {
              setOpenLoader(false);
              return;
            }
            if (policyNumbers.includes(data?.policyNumber)) {
              ToastError("Policy Number Already Exists");
              setSelectedCompany("");
              setSelectedPortal("");
              setSelectedUser("");
              setSelectedPaymentMode("");
              BackToTop();
              setRefreshCount(refreshCount + 1);
              formRef.current?.setFieldValue("paymentMode", null);
            } else if (keys === "SaveAndExit") {
              navigate("/policyList");
              swal({
                title: "Policy Created Successfully!",
                icon: "success",
                buttons: true,
              });

              setDisable(false);
            } else if (keys === "CreateSameUser") {
              setResetFileKey(resetFileKey + 1);
              formRef.current?.setFieldValue("PolicyFile", null);
              formRef.current?.setFieldValue("OtherFile", null);
              setFileTitle(null);
              formRef.current?.setFieldValue("policyNumber", "");
              setRefreshPolicyNumber(refreshPolicyNumber + 1);
              formRef.current?.setFieldValue("totalPremium", "");
              BackToTop();
              swal({
                title: "Policy Created Successfully!",
                icon: "success",
                buttons: true,
              });
              setDisable(false);
            } else {
              setResetFileKey(resetFileKey + 1);
              formRef.current?.setFieldValue("PolicyFile", null);
              formRef.current?.setFieldValue("OtherFile", null);
              setFileTitle("");
              setSelectedCompany("");
              setSelectedPortal("");
              setSelectedUser("");
              setSelectedPaymentMode("");
              setSelectedLoginPortal("");
              BackToTop();
              formRef.current?.resetForm();
              setRefreshCount(refreshCount + 1);
              setShowPaymentMethod("");
              formRef.current?.setFieldValue("paymentMode", null);
              swal({
                title: "Policy Created Successfully!",
                icon: "success",
                buttons: true,
              });
              setDisable(false);
            }
          })
          .catch((err) => {
            ToastError(err?.message);
          })
          .finally(() => {
            setOpenLoader(false);
          });
      }
    } else {
      ToastError("Enter all fields");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };
  const VerifyPolicyNumberFunction = (e) => {
    VerifyPolicyNumber(e)
      .then((res) => {
        // console.log("re", res);
        setShowPolicyErrMsg("");
        setDisplayMappingBtn(false); // Changes by Arun
      })
      .catch((err) => {
        console.log("rsse", err);
        const userName = sessionStorage.getItem("name");
        // Changes by Arun
        if (isAllow.isUser && !err.response.data.message.includes(userName)) {
          setShowPolicyErrMsg("");
          setDisplayMappingBtn(true);
        } else {
          setDisplayMappingBtn(false);
          setShowPolicyErrMsg(err.response.data.message);
          formRef.current?.setFieldValue("policyNumber", null);
          setRefreshPolicyNumber(refreshPolicyNumber + 1);
        }
      });
  };

  // loginPortal added by gokul...
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [selectedLoginPortal, setSelectedLoginPortal] = useState(null);
  const [loginPortalDetails, setLoginPortalDetails] = useState([]);

  const GetLoginPortalData = () => {
    LoginPortalData({
      userId: selectedUserId,
      companyId: selectedCompanyId,
      isActive: true,
    }).then((res) => {
      const filterData1 = res?.data.filter((item) => {
        if (item?.userId === selectedUserId) {
          if (item?.companyId === selectedCompanyId) {
            return item;
          }
        }
      });
      const UserAllData = res?.data.filter((item) => {
        if (item?.userId === "All") {
          if (item?.companyId === selectedCompanyId) {
            return item;
          }
        }
      });

      const UserAdminData = res?.data.filter((item) => {
        if (item?.userId === "Admin") {
          if (item?.companyId === selectedCompanyId) {
            return item;
          }
        }
      });

      setLoginPortalDetails([...filterData1, ...UserAllData, ...UserAdminData]);
    });
  };

  useEffect(() => {
    if (selectedUserId) GetLoginPortalData();
    else setLoginPortalDetails([]);
  }, [selectedUserId, selectedCompanyId]);

  React.useEffect(() => {
    const isallowObj = checkUserType(UserType);
    setIsAllow(isallowObj);
  }, [UserType]);

  return (
    <>
      {/* <Box sx={{ flexGrow: 1 }}>
        <Grid container className="Master_Header_Container">
          <Grid item xs={12} sm={3}>
            <Typography className="Master_Header_Heading">
              Create Policy
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9} />
        </Grid>
      </Box> */}
      <Box className={Styles.formContainer}>
        <Box>
          <Formik
            initialValues={initialValues}
            validationSchema={CreatePolicySchema}
            innerRef={(ref) => {
              if (ref) {
                formRef.current = ref;
              }
            }}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form className={Styles.formContent}>
                <Grid
                  container
                  className="Master_Card_Container"
                  sx={{ border: "none" }}
                >
                  <Grid
                    container
                    alignItems={"center"}
                    className="Master_Card_Sub_Container"
                  >
                    <Grid item xs={12} sm={6}>
                      <Typography className="Master_Card_Tittle">
                        {/* {source == "Profile" ? source : "Add User"} */}
                        {`Create Policy`}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      gap={2}
                      // className="d-flex justify-content-end"
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        className="Master_Card_create_Button w-100"
                        startIcon={
                          <AddIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        sx={{ display: displayMappingBtn ? "none" : "flex" }}
                        onClick={() => SaveAndExit(values, "SaveAndExit")}
                      >
                        {"Save & Exit"}
                      </Button>
                      <Button
                        className="Master_Card_create_Button w-100"
                        startIcon={
                          <AddIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        sx={{ display: displayMappingBtn ? "none" : "flex" }}
                        onClick={() => SaveAndExit(values, "CreateSameUser")}
                      >
                        {UserType == "user" ? "Create New" : "Create Same User"}
                      </Button>
                      <Button
                        className="Master_Card_create_Button w-100"
                        startIcon={
                          <AddIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        sx={{ display: isAllow.isUser ? "none" : "flex" }}
                        onClick={(e) => SaveAndExit(values, "CreateOtherUser")}
                      >
                        {"Add User"}
                      </Button>
                      <Button
                        className="Master_Card_create_Button w-100"
                        startIcon={
                          <AddIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        sx={{ display: !displayMappingBtn ? "none" : "flex" }}
                        onClick={(e) => SaveAndExit(values, "MappingRequired")}
                      >
                        {"Mapping Required"}
                      </Button>
                      {/* <Button
                        className="Master_Card_create_Button w-100"
                        startIcon={
                          <CloudUploadIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        onClick={handleBulkDialogOpen}
                      >
                        {"Bulk Upload"}
                      </Button> */}
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider
                      sx={{
                        backgroundColor: "#EAECF0",
                        borderWidth: 1,
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={{
                    alignItems: "center",
                    padding: "0 5px",
                  }}
                >
                  <Grid item xs={12} sm={1.5}>
                    <Typography
                      className={Styles.formTitleHead}
                      sx={{
                        display: isAllow.isUser ? "none" : "block",
                        ml: 2,
                      }}
                    >
                      User Details
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={10.5}>
                    <Grid container sx={{ p: 2, pt: 4 }} columnSpacing={6}>
                      <Grid item xs={12} sm={4}>
                        <FloatLabel
                          label="Select User"
                          value={values.userId}
                          important="*"
                        >
                          <Autocomplete
                            name="userId"
                            disablePortal
                            className="AutoComplete_InputBox"
                            id="combo-box-demo"
                            value={selectedUser}
                            options={userDetails}
                            onChange={(e, v) => {
                              // console.log(v)
                              if (!v) {
                                setSelectedUser("");
                              } else {
                                setSelectedUser(
                                  v?.name +
                                  " - " +
                                  v?.mobileNumber +
                                  " - " +
                                  v?.email
                                );
                              }
                              setSelectedUserId(v?._id);
                              setFieldValue("userId", v?._id || "");
                            }}
                            renderOption={(props, option) => (
                              <li {...props} key={option._id}>
                                {option?.name +
                                  " - " +
                                  option?.mobileNumber +
                                  " - " +
                                  option?.email}
                              </li>
                            )}
                            isOptionEqualToValue={(e, v) => e.name === v}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                              />
                            )}
                          />
                          <div className="errorMessage ">
                            {errors.userId && touched.userId ? (
                              <div>{errors.userId}</div>
                            ) : (
                              " "
                            )}
                          </div>
                        </FloatLabel>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {/* <hr style={{ display: isAllow.isUser ? "none" : "block" }} /> */}

                <Grid item xs={12}>
                  <Divider
                    sx={{
                      backgroundColor: "#EAECF0",
                      borderWidth: 1,
                    }}
                  />
                </Grid>
                <Grid
                  container
                  sx={{
                    padding: "0 5px",
                  }}
                >
                  <Grid item xs={12} sm={1.5}>
                    <Typography
                      sx={{ ml: 2, pt: 5 }}
                      className={Styles.formTitleHead}
                    >
                      Policy Details
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={10.5}>
                    <Grid
                      container
                      sx={{ p: 2, pt: 4, mb: -2 }}
                      columnSpacing={6}
                    >
                      <Grid item xs={12} sm={4}>
                        <FloatLabel
                          label="Issue Date"
                          value={values.issueDate}
                          important="*"
                        >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              name="issueDate"
                              className="Date_Picker w-100"
                              onChange={(e) =>
                                setFieldValue("issueDate", e?.$d)
                              }
                              key={refreshCount}
                              format={"DD/MM/YYYY"}
                              placeholder=""
                            />
                          </LocalizationProvider>
                          <div className="errorMessage mb-2 mt-2">
                            {errors.issueDate && touched.issueDate ? (
                              <div>{errors.issueDate}</div>
                            ) : (
                              " "
                            )}
                          </div>
                        </FloatLabel>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FloatLabel
                          label="Select Company"
                          value={values.companyId}
                          important="*"
                        >
                          <Autocomplete
                            name="companyId"
                            className="AutoComplete_InputBox"
                            disablePortal
                            id="combo-box-demo"
                            value={selectedCompany}
                            options={companyDetails}
                            onChange={(e, v) => {
                              setSelectedCompany(v?.shortName);
                              setSelectedCompanyId(v?._id);
                              setFieldValue("companyId", v?._id);
                            }}
                            clearIcon={false}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                              />
                            )}
                            renderOption={(props, option, state) => {
                              const isFirstOption = state.index === 0;
                              return (
                                <>
                                  {isFirstOption && (
                                    <li
                                      style={{
                                        padding: "10px 0 4px 16px",
                                        backgroundColor: "gray",
                                        color: "white",
                                        cursor: "pointer",
                                      }}
                                      key="add-user"
                                      onClick={() =>
                                        setOpenCompanyDrawer(true)
                                      }
                                    >
                                      Add Company +
                                    </li>
                                  )}
                                  <li {...props} key={option._id}>
                                    {option.label}
                                  </li>
                                </>
                              );
                            }}
                          />
                          <div className="errorMessage mb-2">
                            {errors.companyId && touched.companyId ? (
                              <div>{errors.companyId}</div>
                            ) : (
                              " "
                            )}
                          </div>
                        </FloatLabel>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={4}
                        sx={{ display: isAllow.isUser ? "none" : "block" }}
                      >
                        <FloatLabel
                          label="Select Policy Portal"
                          value={values.policyPortal}
                          important="*"
                        >
                          <Autocomplete
                            className="AutoComplete_InputBox"
                            name="policyPortal"
                            disablePortal
                            value={selectPortal}
                            options={PolicyPortal}
                            onChange={(e, v) => {
                              setSelectedPortal(v?.label);
                              setFieldValue("policyPortal", v?.label);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                              />
                            )}
                            isOptionEqualToValue={(e, v) =>
                              e?.value === v?.value
                            }
                          />
                          <div className="errorMessage mb-2 mt-2">
                            {errors.policyPortal && touched.policyPortal ? (
                              <div>{errors.policyPortal}</div>
                            ) : (
                              " "
                            )}
                          </div>
                        </FloatLabel>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={4}
                        sx={{ display: isAllow.isUser ? "none" : "block" }}
                      >
                        <FloatLabel
                          label="Select LoginId"
                          value={values.loginIdFull}
                        >
                          <Autocomplete
                            name="loginIdFull"
                            disablePortal
                            className="AutoComplete_InputBox"
                            id="combo-box-demo"
                            value={selectedLoginPortal}
                            options={loginPortalDetails}
                            key={refreshCount}
                            onChange={(e, v) => {
                              setSelectedLoginPortal(v?.loginPortal);
                              setFieldValue(
                                "loginId.companyId",
                                v?.companyId
                              );
                              setFieldValue("loginId.userId", v?.userId);
                              setFieldValue("loginIdFull", v?.loginPortal);
                              setFieldValue("bookingCode", v?.bookingCode);
                              setFieldValue(
                                "subBookingCode",
                                v?.subBookingCode
                              );
                              setFieldValue(
                                "bookingCodeId",
                                v?.bookingCodeId
                              );
                              setFieldValue(
                                "subBookingCodeId",
                                v?.subBookingCodeId
                              );
                            }}
                            renderOption={(props, option) => (
                              <li {...props} key={option._id}>
                                {option.loginPortal}
                              </li>
                            )}
                            isOptionEqualToValue={(e, v) =>
                              e.loginPortal === v
                            }
                            getOptionLabel={(option) =>
                              typeof option === "object" && option !== null
                                ? option.loginPortal || "Unknown"
                                : option
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                              />
                            )}
                          />
                          <div className="errorMessage mb-2 mt-2">
                            {errors.loginIdFull && touched.loginIdFull ? (
                              <div>{errors.loginIdFull}</div>
                            ) : (
                              " "
                            )}
                          </div>
                        </FloatLabel>
                      </Grid>
                      {/* Added by Arun */}
                      <Grid
                        item
                        xs={12}
                        sm={4}
                        sx={{
                          display: isAllow.isUser ? "none" : "block",
                          mb: 4,
                        }}
                      >
                        <FloatLabel
                          label="Booking Code"
                          value={values.bookingCode}
                        >
                          <Field
                            key={refreshPolicyNumber}
                            name="bookingCode"
                            type="string"
                            className="textField w-100"
                          />
                        </FloatLabel>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={4}
                        sx={{
                          display: isAllow.isUser ? "none" : "block",
                          mb: 3,
                        }}
                      >
                        <FloatLabel
                          label="Sub Booking Code"
                          value={values.subBookingCode}
                        >
                          <Field
                            key={refreshPolicyNumber}
                            name="subBookingCode"
                            type="string"
                            className="textField w-100"
                          />
                        </FloatLabel>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Divider
                    sx={{
                      backgroundColor: "#EAECF0",
                      borderWidth: 1,
                    }}
                  />
                </Grid>
                <Grid container sx={{ alignItems: "center", padding: "0 5px" }}>
                  <Grid item xs={12} sm={1.5}>
                    <Typography sx={{ ml: 2 }} className={Styles.formTitleHead}>
                      Premium Details
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={10.5} sx={{ mb: 1 }}>
                    <Grid
                      container
                      sx={{ p: 2, pt: 4, mb: -3 }}
                      columnSpacing={6}
                    >
                      <Grid item xs={12} sm={4}>
                        <FloatLabel
                          label="Policy Number"
                          value={values.policyNumber}
                          important="*"
                        >
                          <Field
                            className="textField w-100"
                            name="policyNumber"
                            id="policyNumber"
                            onKeyDown={handleKeyDown}
                            key={refreshPolicyNumber}
                            onBlur={(e) =>
                              VerifyPolicyNumberFunction(e.target.value)
                            }
                          />
                          <div className="errorMessage mb-2">
                            {showPolicyErrMsg}
                          </div>
                          <div className="errorMessage mb-2 mt-2">
                            {errors.policyNumber && touched.policyNumber ? (
                              <div>{errors.policyNumber}</div>
                            ) : (
                              " "
                            )}
                          </div>
                        </FloatLabel>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FloatLabel
                          label="Total Premium"
                          value={values.totalPremium}
                          important="*"
                        >
                          <Field
                            key={refreshPolicyNumber}
                            name="totalPremium"
                            type="number"
                            className="textField w-100"
                          />
                          <div className="errorMessage mb-2 mt-2">
                            {errors.totalPremium && touched.totalPremium ? (
                              <div>{errors.totalPremium}</div>
                            ) : (
                              " "
                            )}
                          </div>
                        </FloatLabel>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FloatLabel
                          label="Payment Mode"
                          value={values.paymentMode}
                          important="*"
                        >
                          <Autocomplete
                            className="AutoComplete_InputBox"
                            options={PaymentDetails}
                            isOptionEqualToValue={(option, value) =>
                              option?.value === value?.value
                            }
                            clearIcon={false}
                            value={selectedPaymentMode}
                            name="paymentMode"
                            onChange={(option, value) => {
                              setSelectedPaymentMode(value?.label);
                              PaymentFunction(value);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                              />
                            )}
                          />
                          <div className="errorMessage mb-2 mt-2">
                            {errors.paymentMode && touched.paymentMode ? (
                              <div>{errors.paymentMode}</div>
                            ) : (
                              " "
                            )}
                          </div>
                        </FloatLabel>
                      </Grid>
                      {showPaymentMethod === 3 ? (
                        <>
                          <Grid item xs={12} sm={4}>
                            <FloatLabel
                              label="Cheque Number"
                              value={values.chequeNumber}
                              important="*"
                            >
                              <Field
                                name="chequeNumber"
                                className="textField w-100"
                              />
                              <div className="errorMessage mb-2 mt-2">
                                {errors.chequeNumber && touched.chequeNumber ? (
                                  <div>{errors.chequeNumber}</div>
                                ) : (
                                  " "
                                )}
                              </div>
                            </FloatLabel>
                          </Grid>
                          <Grid item xs={12} sm={4} className="datePicker">
                            <FloatLabel
                              label="Cheque Date"
                              value={values.chequeDate}
                              important="*"
                            >
                              {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}
                              <DatePicker
                                name="chequeDate"
                                className="Date_Picker w-100"
                                onChange={(e) =>
                                  setFieldValue(
                                    "chequeDate",
                                    e?.$d ? e?.$d : null
                                  )
                                }
                                placeholder=""
                              />
                              {/* </LocalizationProvider> */}
                              <div className="errorMessage mb-2 mt-2">
                                {errors.chequeDate && touched.chequeDate ? (
                                  <div>{errors.chequeDate}</div>
                                ) : (
                                  " "
                                )}
                              </div>
                            </FloatLabel>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <FloatLabel
                              label="Bank Name"
                              value={values.bankName}
                              important="*"
                            >
                              <Field
                                className="textField w-100"
                                name="bankName"
                              />
                              <div className="errorMessage mb-2 mt-2">
                                {errors.bankName && touched.bankName ? (
                                  <div>{errors.bankName}</div>
                                ) : (
                                  " "
                                )}
                              </div>
                            </FloatLabel>
                          </Grid>
                        </>
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Divider
                    sx={{
                      backgroundColor: "#EAECF0",
                      borderWidth: 1,
                    }}
                  />
                </Grid>
                <Grid container sx={{ alignItems: "center", padding: "0 5px" }}>
                  <Grid item xs={12} sm={1.5}>
                    <Typography sx={{ ml: 2 }} className={Styles.formTitleHead}>
                      File Upload
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={10.5} sx={{ mb: 1 }}>
                    <Grid
                      container
                      sx={{ p: 2, pt: 4, mb: -3 }}
                      columnSpacing={6}
                    >
                      <Grid item xs={12} sm={4} className="File-Upload">
                        <FileUploader
                          handleChange={(e) => {
                            console.log("e", e);
                            setFieldValue("PolicyFile", e);
                            setFileTitle({ ...fileTitle, policyFile: e.name });
                          }}
                          name="PolicyFile"
                          label="Upload Your Policy File"
                          dropMessageStyle={{
                            color: "red",
                            border: "none",
                            borderRadius: "0px",
                          }}
                          // types={["PDF"]}
                          key={resetFileKey}
                        />
                        <div
                          className="fileTitle"
                          style={{
                            display: "flex",
                            justifyContent: fileTitle?.policyFile
                              ? "space-between"
                              : "flex-end",
                            // marginBottom: "-10px",
                          }}
                        >
                          {fileTitle?.policyFile && (
                            <Typography
                              sx={{
                                color: "black",
                                fontSize: "12px",
                                fontFamily: "Inter",
                              }}
                            >
                              {fileTitle?.policyFile
                                ? fileTitle?.policyFile
                                : null}
                            </Typography>
                          )}
                          <Typography
                            sx={{
                              color: "#959595",
                              fontSize: "12px",
                              fontFamily: "Inter",
                            }}
                          >
                            PDF Files Only
                          </Typography>
                        </div>
                        <div className="errorMessage">
                          {errors.PolicyFile && touched.PolicyFile ? (
                            <div>{errors.PolicyFile}</div>
                          ) : (
                            " "
                          )}
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={4} className="File-Upload">
                        <FileUploader
                          handleChange={(e) => {
                            setFieldValue("OtherFile", e);
                            setFileTitle({ ...fileTitle, otherFile: e.name });
                          }}
                          name="OtherFile"
                          label="Upload Your Other documents"
                          dropMessageStyle={{
                            color: "red",
                            border: "none",
                            borderRadius: "0px",
                          }}
                          multiple={false}
                          key={resetFileKey}
                        />
                        <div className="fileTitle">
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: "12px",
                              fontFamily: "Inter",
                            }}
                          >
                            {fileTitle?.otherFile ? fileTitle?.otherFile : null}
                          </Typography>
                        </div>
                      </Grid>
                      {/* <Grid item xs={12} sm={4}>
                  <button
                    className="w-100 Common_Button"
                    onClick={(e) => AutoFillFunction(values)}
                  >
                    Auto Fill
                  </button>
                </Grid> */}
                      {/* <Grid item xs={12} sm={12}>
                  {pdfData ? (
                    <div style={{ color: "BLUE" }}>
                      {" "}
                      {JSON.stringify(pdfData, null, 2)}
                    </div>
                  ) : (
                    ""
                  )}
                </Grid> */}
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Box>
      </Box>
      <Dialog
        open={bulkDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleBulkDialogClose}
        fullWidth
        maxWidth="sm"
      >
        <Box p={3} display="flex" flexDirection="column" gap={2}>
          <Typography variant="h6" fontWeight={600}>
            Bulk Upload Policies
          </Typography>
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "4px",
              backgroundColor: "#fafafa"
            }}
          >
            <Autocomplete
              options={BULK_COMPANY_OPTIONS}
              value={bulkCompany}
              onChange={async (_, value) => {
                setBulkCompany(value);
                // Validate file name if file is already selected
                if (bulkFileName && value) {
                  const validation = validateBulkFileName(bulkFileName, value);
                  if (!validation.isValid) {
                    setBulkFileNameError(validation.error);
                    ToastError(validation.error);
                    // Clear preview if validation fails
                    setBulkPreview([]);
                  } else {
                    setBulkFileNameError("");
                    // Re-parse the file if validation passes and file object exists
                    if (bulkFileObject) {
                      const records = await parseExcelFile(bulkFileObject);
                      if (records) {
                        setBulkPreview(records);
                      }
                    } else if (bulkPreview.length === 0) {
                      // If no file object but we have a filename, try to re-parse
                      // This handles the case where file was uploaded but not parsed due to validation
                      ToastError("Please re-upload the Excel file.");
                    }
                  }
                } else {
                  setBulkFileNameError("");
                  // Clear file if company is deselected
                  if (!value && bulkFileName) {
                    setBulkFileName("");
                    setBulkPreview([]);
                    setBulkFileObject(null);
                    if (bulkFileInputRef.current) {
                      bulkFileInputRef.current.value = "";
                    }
                  }
                }
              }}
              getOptionLabel={(option) => option?.label ?? ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Company *"
                  required
                  error={!bulkCompany && bulkFileName ? true : false}
                  helperText={
                    !bulkCompany && bulkFileName
                      ? "Company selection is required"
                      : ""
                  }
                />
              )}
            />
          </Box>
          <Box>
            <Button
              variant="outlined"
              component="label"
              startIcon={<CloudUploadIcon />}
              disabled={!bulkCompany}
            >
              {bulkFileName ? "Change Excel" : "Select Excel"}
              <input
                type="file"
                hidden
                accept=".xlsx,.xls"
                onChange={handleBulkFileChange}
                ref={bulkFileInputRef}
                disabled={!bulkCompany}
              />
            </Button>
            {!bulkCompany && (
              <Typography
                variant="caption"
                display="block"
                sx={{ mt: 0.5, color: "error.main", fontSize: "0.75rem" }}
              >
                Please select a company before uploading the Excel file.
              </Typography>
            )}
            {bulkFileName ? (
              <Typography
                variant="caption"
                display="block"
                sx={{
                  mt: 1,
                  color: bulkFileNameError ? "error.main" : "text.primary",
                  fontWeight: bulkFileNameError ? 600 : 400,
                }}
              >
                {bulkFileName}
              </Typography>
            ) : null}
            {bulkFileNameError ? (
              <Typography
                variant="caption"
                display="block"
                sx={{ mt: 0.5, color: "error.main", fontSize: "0.75rem" }}
              >
                {bulkFileNameError}
              </Typography>
            ) : null}
          </Box>
          {bulkPreview.length > 0 && (
            <Box>
              <Typography variant="body2" color="text.secondary">
                Detected {bulkPreview.length} row
                {bulkPreview.length > 1 ? "s" : ""}. Columns recognised include
                Policy Number, Customer Name, Make, Model, Fuel Type, Vehicle No,
                Year Of Manufacture, OD Discount, Prop Date, OD Net Premium, TP
                Premium, Gross Premium, CC, Seating Capacity, Add-On Premium and
                User ID.
              </Typography>
              <BulkUploadPreview rows={bulkPreview} />
            </Box>
          )}
          {bulkResults && (
            <Box>
              <Typography variant="subtitle2" color="success.main">
                Created: {bulkResults.success}
              </Typography>
              <Typography
                variant="subtitle2"
                color={bulkResults.failed ? "error.main" : "text.secondary"}
              >
                Failed: {bulkResults.failed}
              </Typography>
              {!!bulkResults.errors?.length && (
                <Box
                  mt={1}
                  sx={{
                    maxHeight: 160,
                    overflow: "auto",
                    bgcolor: "#fff5f5",
                    borderRadius: 1,
                    p: 1,
                  }}
                >
                  {bulkResults.errors.map((item, index) => (
                    <Typography
                      variant="caption"
                      color="error"
                      display="block"
                      key={`${item.row}-${index}`}
                    >
                      Row {item.row}: {item.message}
                    </Typography>
                  ))}
                </Box>
              )}
            </Box>
          )}
          <Box display="flex" justifyContent="flex-end" gap={1}>
            <Button onClick={handleBulkDialogClose} disabled={bulkProcessing}>
              Close
            </Button>
            <Button
              variant="contained"
              startIcon={<CloudUploadIcon />}
              onClick={handleBulkCreate}
              disabled={bulkProcessing || !bulkCompany || !bulkPreview.length || !!bulkFileNameError}
            >
              {bulkProcessing
                ? "Processing..."
                : `Create${bulkPreview.length ? ` (${bulkPreview.length})` : ""}`}
            </Button>
          </Box>
        </Box>
      </Dialog>
      <Loader open={openLoader} />
      <Dialog
        open={openCompanyDrawer}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            maxWidth: "50%",
          },
        }}
      >
        {openCompanyDrawer ? (
          <AddCompany
            title="Create"
            formType="add"
            setOpenCompanyDrawer={setOpenCompanyDrawer}
            GetActiveData={GetCompanyDetails}
          />
        ) : null}
      </Dialog>
    </>
  );
};

export default Policycreate;
